module.exports = __webpack_public_path__ + "static/media/dollar.e4b91f8b.svg";